export default {
  state: {
    wsData: null, // 用来存储 WebSocket 数据
    isConnected: false, // WebSocket 连接状态
    socket: null, // WebSocket 实例
  },
  mutations: {
    setWsData(state, data) {
      state.wsData = data; // 设置 WebSocket 数据
    },
    setConnectionStatus(state, status) {
      state.isConnected = status; // 设置 WebSocket 连接状态
    },
    setSocket(state, socket) {
      state.socket = socket; // 保存 WebSocket 实例
    },
  },
  actions: {
    connectWebSocket({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        const token = localStorage
          .getItem(process.env.VUE_APP_TOKEN_NAME)
          .replace('Bearer ', ''); // 获取 token
        const wsUrl = `${process.env.VUE_APP_WS_URL}/?token=${token}`;
        const socket = new WebSocket(wsUrl);

        // 连接成功
        socket.addEventListener('open', () => {
          commit('setConnectionStatus', true); // 更新连接状态
          commit('setSocket', socket); // 保存 WebSocket 实例
          resolve();
        });

        // 连接关闭
        socket.addEventListener('close', () => {
          commit('setConnectionStatus', false); // 更新连接状态
        });

        // 连接错误
        socket.addEventListener('error', (err) => {
          commit('setConnectionStatus', false); // 更新连接状态
          reject(err);
        });

        // 监听消息
        socket.addEventListener('message', (event) => {
          const parsedMessage = JSON.parse(event.data);
          dispatch('updateWsData', parsedMessage); // 更新 Vuex 中的数据

          // 消息中心推送
          if (parsedMessage.type === 'new_message') {
            dispatch('message/handleWsPush', parsedMessage, { root: true });
          }
        });
      });
    },

    // 更新 WebSocket 数据
    updateWsData({ commit }, data) {
      commit('setWsData', data); // 更新 WebSocket 数据
    },

    // 发送消息
    sendMessage({ state }, message) {
      return new Promise((resolve, reject) => {
        if (state.socket && state.socket.readyState === WebSocket.OPEN) {
          state.socket.send(message);
          resolve();
        } else {
          reject(new Error('WebSocket 未连接'));
        }
      });
    },

    // 关闭 WebSocket 连接
    closeWebSocket({ commit, state }) {
      if (state.socket) {
        state.socket.close();
        commit('setConnectionStatus', false);
        commit('setSocket', null);
      }
    },
  },
  getters: {
    getWsData: (state) => state.wsData, // 获取 WebSocket 数据
    isWebSocketConnected: (state) => state.isConnected, // 获取 WebSocket 连接状态
  },
};
